<template>
  <v-container class="content-wrapper" fluid>
    <v-row v-if="!loading && providers.length == 0">
      <v-col cols="12">
        <v-btn
          v-show="isMarketplaceProvider"
          depressed
          rounded
          small
          color="blue"
          class="white--text font-weight-bold"
          @click="goBack"
        >
          <v-icon color="black" small class="mr-2">
            mdi-arrow-left
          </v-icon>
          Back
        </v-btn>
      </v-col>
      <v-col cols="12">
        <p>
          No Providers found.
        </p>
      </v-col>
    </v-row>
    <v-row v-else class="mb-10 justify-start">
      <v-col
        cols="12"
        xl="6"
        lg="4"
        md="6"
        sm="6"
        xs="12"
        class="pa-3"
        v-for="(provider, index) in providers"
        :key="'provider-' + index"
      >
        <v-hover v-slot="{ hover }">
          <v-card
            class="d-flex flex-column"
            elevation="3"
            style="border-radius: 24px; height: 100%;"
            :class="{ 'on-hover': hover }"
            @click="handleCardClick(provider, $event)"
          >
            <v-row class="pa-2 ma-2 d-flex  align-center flex-grow-1">
              <v-col
                cols="12"
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="12"
                class="text-start flex-grow-1"
                style="max-width: fit-content;"
              >
                <v-avatar rounded="0" size="100">
                  <v-img contain :src="provider.logoUrl">
                    <template v-slot:placeholder>
                      <v-img lazy-src="@/assets/img/blur.jpg"></v-img>
                    </template>
                  </v-img>
                </v-avatar>
              </v-col>
              <v-col
                cols="12"
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="12"
                class="text-start flex-grow-1"
                style="max-width: fit-content;"
              >
                <div class="d-flex flex-column justify-center">
                  <b style="font-size: 12px;">{{ provider.name }}</b>
                  <div class="mb-1">
                    <label class="primary200--text">Hosting Institution</label>
                    <div v-if="$store.getters.roles">
                      <router-link
                        v-if="$route.fullPath.includes('search-marketplace')"
                        :to="{
                          name: 'OverviewHostingInstitution',
                          params: { id: provider.hostingInstitution.id },
                          query: {
                            marketplaceProvidersViewAll: true,
                            searchBar: true,
                            ...getParams(),
                            ...localFilteredParams,
                          },
                        }"
                        style="text-decoration: underline; color: inherit;"
                      >
                        {{ provider.hostingInstitution.name }}
                      </router-link>
                      <router-link
                        v-else
                        :to="{
                          name: 'OverviewHostingInstitution',
                          params: { id: provider.hostingInstitution.id },
                          query: {
                            marketplaceProvidersViewAll: true,
                            filters: true,
                            ...getParams(),
                            ...localFilteredParams,
                          },
                        }"
                        style="text-decoration: underline; color: inherit;"
                      >
                        {{ provider.hostingInstitution.name }}
                      </router-link>
                    </div>
                    <div v-else>
                      <router-link
                        v-if="$route.fullPath.includes('public-search-marketplace')"
                        :to="{
                          name: 'PublicOverviewHostingInstitution',
                          params: { id: provider.hostingInstitution.id },
                          query: {
                            marketplaceProvidersViewAll: true,
                            searchBar: true,
                            ...getParams(),
                            ...localFilteredParams,
                          },
                        }"
                        style="text-decoration: underline; color: inherit;"
                      >
                        {{ provider.hostingInstitution.name }}
                      </router-link>
                      <router-link
                        v-else
                        :to="{
                          name: 'PublicOverviewHostingInstitution',
                          params: { id: provider.hostingInstitution.id },
                          query: {
                            marketplaceProvidersViewAll: true,
                            filters: true,
                            ...getParams(),
                            ...localFilteredParams,
                          },
                        }"
                        style="text-decoration: underline; color: inherit;"
                      >
                        {{ provider.hostingInstitution.name }}
                      </router-link>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-spacer></v-spacer>
            <v-divider
              v-if="provider.email != null || provider.socialMedia.length > 0"
              class="custom-divider"
            ></v-divider>

            <v-card-actions class="mt-0 pt-0">
              <v-row align="center" class="d-flex flex-grow-1">
                <v-col class="flex-grow-1">
                  <div>
                    <social-media :list="provider.socialMedia"></social-media>
                  </div>
                </v-col>
                <v-col class="d-flex justify-end" v-if="provider.email != null">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="!$store.getters.roles"
                        @click.stop="openLoginModal(provider.id)"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        style="min-width: auto;"
                      >
                        <v-icon style="color: rgba(0, 0, 0, 0.87)!important;">
                          mdi-email-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Contact</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <!-- Pagination -->
    <v-row v-if="pagesLength > 1">
      <v-spacer></v-spacer>
      <v-col cols="4" md="2" class="justify-end d-flex flex-row align-center">
        <div>{{ totalItems }} Results</div>
      </v-col>
      <v-col cols="8" md="2" class="justify-end d-flex flex-row align-center">
        <div class="pr-2">Show:</div>
        <div style="max-width: 90px">
          <v-select
            v-model="options.itemsPerPage"
            :items="[10, 20, 30, 40, 50, { text: 'All', value: -1 }]"
            dense
            outlined
            hide-details
            @change="onItemsPerPageChange"
          ></v-select>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="justify-end d-flex flex-row align-center">
        <v-pagination
          v-model="options.page"
          :length="pagesLength"
          :total-visible="7"
          @input="getFilteredDataFromApi"
        ></v-pagination>
      </v-col>
    </v-row>

    <!-- Non registered dialog -->
    <v-dialog v-model="modalLogIn" max-width="1000px" :retain-focus="false" hide-overlay>
      <v-card class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8">
        <v-card-title class="px-0 py-0">
          <v-row class="mx-0 px-2" align="center">
            <v-col cols="11" class="text-center d-flex justify-center align-center">
              This action requires authentication
            </v-col>
            <v-col cols="1" class="pl-0">
              <v-btn fab small text @click="modalLogIn = false">
                <v-icon color="neutral500">
                  mdi-close
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider class="mt-1 mb-6 my-sm-6 my-lg-6 my-xl-6 my-md-6"></v-divider>
        <v-card-text class="pa-0 text-center">
          Only authenticated users are allowed to perform this action. Please
          <router-link :to="{ name: 'OverviewProvider', params: { id: selectedProviderId } }"
            ><span class="font-weight-bold">Log In</span></router-link
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import EventBus from '@/helpers/event-bus.js';
import SocialMedia from '@/components/marketplace/SocialMedia';

export default {
  name: 'MarketplaceProvidersFilteredViewAll',
  components: { SocialMedia },
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      providers: [],
      totalItems: 0,
      pagesLength: null,
      loading: false,
      provider: {
        name: '',
        logo: '',
        logoUrl: '',
        provider: {
          name: '',
          id: null,
        },
        isFavorite: false,
      },
      currentSortParams: '',
      modalLogIn: false,
      selectedProviderId: '',
      localFilteredParams: {},
    };
  },
  props: {
    filteredParams: {
      type: Object,
    },
    sortParams: {
      type: String,
    },
    searchMarketplace: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (this.$route.query.filters === 'true') {
      const query = { ...this.$route.query };
      delete query.index;
      delete query.marketplaceProvidersViewAll;
      delete query.selectedCatalogue;
      delete query.size;
      delete query.filters;
      if (query.orderable !== undefined) {
        query.orderable = query.orderable === 'true';
      }
      this.localFilteredParams = query;
      console.log('Filters from URL:', this.localFilteredParams);
    } else {
      this.localFilteredParams = { ...this.filteredParams };
    }
    if (this.$route.query.index !== undefined) {
      const index = parseInt(this.$route.query.index);
      this.options.page = index + 1;
    }
    if (this.$route.query.size !== undefined) {
      this.options.itemsPerPage = parseInt(this.$route.query.size);
    }
    this.currentSortParams = this.sortParams || '';
  },
  mounted() {
    if (this.$route.query.fromTable) {
      this.options.page = 1;
    }
    this.getFilteredDataFromApi();
  },
  watch: {
    filteredParams: {
      deep: true,
      immediate: false,
      handler(newVal) {
        console.log('filteredParams changed:', newVal);
        this.localFilteredParams = { ...newVal };
        this.options.page = 1;
        this.getFilteredDataFromApi();
      },
    },
    sortParams: {
      deep: true,
      immediate: false,
      handler(newVal) {
        console.log('sortParams changed:', newVal);
        this.currentSortParams = newVal;
        this.getFilteredDataFromApi(newVal);
      },
    },
    '$route.query': {
      immediate: false,
      handler(query) {
        if (query.index !== undefined) {
          const index = parseInt(query.index);
          this.options.page = index + 1;
        }
        if (query.size !== undefined) {
          this.options.itemsPerPage = parseInt(query.size);
        }
      },
    },
  },
  computed: {
    isMarketplaceProvider() {
      return (
        this.$route.path === '/marketplace/providers' ||
        this.$route.path === '/public-catalogue-marketplace/providers'
      );
    },
  },
  methods: {
    getFilteredDataFromApi(sortParams = this.currentSortParams) {
      const paginationParams = this.getParams();

      const filteredParams = {
        ...paginationParams,
        ...this.localFilteredParams,
      };

      this.deleteEmptyProperties(filteredParams);

      console.log('Combined params for request:', filteredParams);

      this.loading = true;
      EventBus.$emit('waiting', true);

      this.axios
        .get(
          `/api/v1/providers?${new URLSearchParams(filteredParams)}${
            sortParams ? `&${sortParams}` : ''
          }`,
        )
        .then(response => {
          console.log('Get Filtered Data:', response.data);
          this.providers = response.data.content;
          this.totalItems = response.data.total;
          this.pagesLength = response.data.pagesLength;
        })
        .catch(error => {
          console.error('Error fetching providers:', error);
        })
        .finally(() => {
          this.loading = false;
          EventBus.$emit('waiting', false);
        });
    },
    deleteEmptyProperties(obj) {
      if (!obj || typeof obj !== 'object') {
        return;
      }

      if (Array.isArray(obj)) {
        obj.forEach((item, index) => {
          if (item === null || item === undefined || item === '') {
            obj.splice(index, 1);
          } else if (typeof item === 'object') {
            this.deleteEmptyProperties(item);
            if (Object.keys(item).length === 0) {
              obj.splice(index, 1);
            }
          }
        });
      } else {
        for (const key in obj) {
          if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
            delete obj[key];
          } else if (Array.isArray(obj[key])) {
            this.deleteEmptyProperties(obj[key]);
            if (obj[key].length === 0) {
              delete obj[key];
            }
          } else if (typeof obj[key] === 'object') {
            this.deleteEmptyProperties(obj[key]);
            if (Object.keys(obj[key]).length === 0) {
              delete obj[key];
            }
          }
        }
      }
    },
    onItemsPerPageChange() {
      this.options.page = 1;
      this.getFilteredDataFromApi();
    },
    getParams() {
      const { page, itemsPerPage } = this.options;
      const query = {
        index: itemsPerPage === -1 ? 0 : page - 1,
        size: itemsPerPage === -1 ? 1000 : itemsPerPage,
      };
      return query;
    },
    handleCardClick(provider, event) {
      if (event.target.closest('a, button, .v-btn, .v-icon')) {
        return;
      }
      this.redirectToOverview(provider);
    },
    redirectToOverview(item) {
      if (this.$store.getters.roles != null) {
        const marketplaceProvidersViewAll = true;
        const providerSearchMarketplace = true;

        if (this.searchMarketplace) {
          this.$router.push({
            name: 'OverviewProvider',
            params: { id: item.id },
            query: {
              providerSearchMarketplace,
              filters: true,
              ...this.getParams(),
              text: this.$route.query.text,
            },
          });
        } else {
          this.$router.push({
            name: 'OverviewProvider',
            params: { id: item.id },
            query: {
              marketplaceProvidersViewAll,
              filters: true,
              ...this.getParams(),
              ...this.localFilteredParams,
            },
          });
        }
      } else {
        const marketplaceProvidersViewAll = true;
        const providerSearchMarketplace = true;

        if (this.searchMarketplace) {
          this.$router.push({
            name: 'PublicOverviewProvider',
            params: { id: item.id },
            query: {
              providerSearchMarketplace,
              filters: true,
              ...this.getParams(),
              text: this.$route.query.text,
            },
          });
        } else {
          this.$router.push({
            name: 'PublicOverviewProvider',
            params: { id: item.id },
            query: {
              marketplaceProvidersViewAll,
              filters: true,
              ...this.getParams(),
              ...this.localFilteredParams,
            },
          });
        }
      }
    },
    goBack() {
      this.$emit('changeTab');
    },
    openLoginModal(providerId) {
      this.modalLogIn = true;
      this.selectedProviderId = providerId;
    },
  },
};
</script>

<style scoped>
.custom-divider {
  padding-top: 5px;
  margin: 0 35px;
  border-top-width: 2px;
  border-top-style: solid;
  border-top-color: rgba(195, 194, 199, 1);
}
</style>
